// ─── Noir Vinyl V1 ────────────────────────────────────────────
// Config-driven rebuild of NoirVinyl template.
// Dark album sleeve aesthetic with vinyl disc and gold accents.

export const noirVinylV1 = {
  templateId: 'noir-vinyl-v1',
  name: 'Noir Vinyl',
  category: 'wedding',
  description: 'Dark cinematic vinyl aesthetic with gold accents and rotating disc',
  theme: {
    palette: 'noir-gold',
    fontPair: 'playfair-inter',
    radius: 'soft',
    shadow: 'card',
    overlay: 'dark-soft',
    sectionSpacing: { mobileY: '4rem', desktopY: '6rem' },
  },
  settings: {
    musicEnabled: true,
    countdownEnabled: false,
    rsvpEnabled: true,
    showMapLink: true,
  },
  sections: [
    {
      id: 'hero-1',
      type: 'hero',
      variant: 'hero-album-sleeve',
      animation: { title: 'stagger-text' },
      visible: true,
      editableRules: {
        fields: ['title', 'dateText', 'subtitle', 'backgroundImage', 'songTitle', 'artistName', 'vinylCoverImage', 'musicUrl'],
        locked: ['layout', 'spacing', 'typographyScale'],
      },
      data: {
        title: 'Sofia & Miguel',
        dateText: '',
        subtitle: '',
        backgroundImage: '',
        songTitle: 'Our Song',
        artistName: 'Artist',
        vinylCoverImage: '',
        vinylColor: '',
        musicUrl: '',
      },
    },
    {
      id: 'story-1',
      type: 'story',
      variant: 'story-single-column',
      animation: { text: 'fade-up' },
      visible: true,
      editableRules: {
        fields: ['title', 'paragraph'],
        locked: ['layout', 'spacing'],
      },
      data: {
        title: 'Our Story',
        paragraph: '',
      },
    },
    {
      id: 'details-1',
      type: 'event-details',
      variant: 'details-grid',
      animation: { items: 'stagger-cards' },
      visible: true,
      editableRules: {
        fields: ['items', 'venue', 'address'],
        locked: ['grid', 'spacing'],
      },
      data: {
        items: [],
        venue: '',
        address: '',
      },
    },
    {
      id: 'timeline-1',
      type: 'timeline',
      variant: 'timeline-vertical',
      animation: { items: 'stagger-cards' },
      visible: true,
      editableRules: {
        fields: ['items'],
        locked: ['layout', 'spacing'],
      },
      data: {
        title: 'Schedule',
        items: [],
      },
    },
    {
      id: 'rsvp-1',
      type: 'rsvp',
      variant: 'rsvp-card',
      animation: { section: 'fade-up' },
      visible: true,
      editableRules: {
        fields: ['title', 'description'],
        locked: ['validationRules', 'inputStyle'],
      },
      data: {
        title: 'RSVP',
        description: "We'd love to know if you can make it",
      },
    },
    {
      id: 'footer-1',
      type: 'footer',
      variant: 'footer-centered',
      animation: { section: 'fade-up' },
      visible: true,
      editableRules: {
        fields: ['closingMessage', 'names'],
        locked: ['layout', 'spacing'],
      },
      data: {
        closingMessage: "We can't wait to celebrate with you",
        names: 'Sofia & Miguel',
        contactText: '',
      },
    },
  ],
};
